import { Badge } from '@/components/ui/Badge'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import type { GateBadgeProps } from './types'

export function GateBadge({ blocked, gateInfo }: GateBadgeProps) {
  if (!blocked) {
    return (
      <span data-testid="gate-badge-unlocked">
        <Badge variant="success">Liberado</Badge>
      </span>
    )
  }

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span data-testid="gate-badge-blocked">
            <Badge variant="error">BLOQUEADO</Badge>
          </span>
        </TooltipTrigger>
        {gateInfo && (
          <TooltipContent data-testid="gate-badge-tooltip">
            Requisito: {gateInfo.ref} — mín. {gateInfo.min}%, atual: {gateInfo.atual}%
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  )
}
